import { render, staticRenderFns } from "./SyncTextBook.vue?vue&type=template&id=1c5bcb90&scoped=true&"
import script from "./SyncTextBook.vue?vue&type=script&lang=js&"
export * from "./SyncTextBook.vue?vue&type=script&lang=js&"
import style0 from "./SyncTextBook.vue?vue&type=style&index=0&id=1c5bcb90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5bcb90",
  null
  
)

export default component.exports